import {
  Dropdown,
  DropdownButton,
  DropdownItem,
  DropdownItems,
} from "@transfr-inc/dashboard-components/forms";

export const ActivitiesFilter = ({
  onOptionSelected,
  selected,
  activityOptions,
  placeholder = "All Activities",
  icon = ["fa-light", "fa-filter"],
}) => {
  return (
    <Dropdown
      onOptionSelected={onOptionSelected}
      selected={selected}
      disabled={!activityOptions?.length}
      filled
    >
      <DropdownButton placeholder={placeholder} icon={icon} clearEnabled>
        {selected?.title}
      </DropdownButton>
      <DropdownItems>
        {activityOptions.map((option) => (
          <DropdownItem key={option.id} value={option}>
            {option.title}
          </DropdownItem>
        ))}
      </DropdownItems>
    </Dropdown>
  );
};
